import { useToast } from "@agney/ir-toast";
import React, { useEffect } from "react";
import { apiErrorNotifier } from "../../../services/apiErrorNotifier";

/**
 * Shows a toast for any API failure the service layer reports. Mounted once,
 * inside App's ToastProvider, so every screen gets error feedback without each
 * one having to implement it. Renders nothing itself.
 *
 * Identical messages arriving back to back are collapsed: a screen that fires
 * several requests at once (the Status Board opens with half a dozen) would
 * otherwise stack the same toast once per request when the server is down.
 */
const DUPLICATE_WINDOW_MS = 4000;

const ApiErrorToaster: React.FC = () => {
  const Toast = useToast();

  useEffect(() => {
    let lastMessage = "";
    let lastShownAt = 0;

    const subscription = apiErrorNotifier.apiErrors.subscribe((event) => {
      const now = Date.now();
      if (event.message === lastMessage && now - lastShownAt < DUPLICATE_WINDOW_MS) {
        return;
      }
      lastMessage = event.message;
      lastShownAt = now;
      Toast.error(event.message);
    });

    return () => subscription.unsubscribe();
  }, [Toast]);

  return null;
};

export default ApiErrorToaster;
